var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
import { TranslatedText } from '../../atoms/TranslatedText';
import { ContentContainer } from '../../templates/ContentContainer';
import { ColorComponent } from './styled';
export var ChartLegendElement = function (_a) {
    var design = _a.design, values = _a.values;
    var _b = useDesign(design), components = _b.components, config = _b.config, schema = _b.schema;
    var color = config.color, showOnly = config.showOnly, translatedTextProps = __rest(config, ["color", "showOnly"]);
    if (showOnly && showOnly !== values.chartType)
        return null;
    return (_jsxs(GenericComponent, __assign({ schema: schema, "data-design": design }, { children: [_jsx(ColorComponent, { color: color }), _jsx(TranslatedText, __assign({}, translatedTextProps)), components.content && _jsx(ContentContainer, { design: components.content })] })));
};
ChartLegendElement.displayName = 'ChartLegendElement';
